import { MediaMatches, MediaMatchName, ViewportMatchName } from 'interfaces/viewport'
import { PayloadAction } from 'interfaces/action'
import { createPayloadAction } from 'helpers/actionsHelpers'

export const SET_FULLSCREEN_MODE = 'SET_FULLSCREEN_MODE' as const
type SetFullscreenMode = PayloadAction<typeof SET_FULLSCREEN_MODE, boolean>
export const setFullscreenModeActionCreator = (isFullscreenEnabled: boolean): SetFullscreenMode =>
  createPayloadAction(SET_FULLSCREEN_MODE, isFullscreenEnabled)

export const SET_VIEWPORT_MATCH = 'SET_VIEWPORT_MATCH' as const
type SetViewportMatch = PayloadAction<typeof SET_VIEWPORT_MATCH, ViewportMatchName>
export const setViewportMediaMatchActionCreator = (matchName: ViewportMatchName): SetViewportMatch =>
  createPayloadAction(SET_VIEWPORT_MATCH, matchName)

export const SET_MEDIA_MATCH = 'SET_MEDIA_MATCH' as const
type SetMediaMatch = PayloadAction<typeof SET_MEDIA_MATCH, { name: MediaMatchName, value: boolean }>
export const setMediaMatchActionCreator = (name: MediaMatchName, value: boolean): SetMediaMatch =>
  createPayloadAction(SET_MEDIA_MATCH, { name, value })

export const APPEND_MEDIA_MATCHES = 'APPEND_MEDIA_MATCHES' as const
type SetMediaMatches = PayloadAction<typeof APPEND_MEDIA_MATCHES, MediaMatches>
export const setMediaMatchesActionCreator = (matches: MediaMatches): SetMediaMatches =>
  createPayloadAction(APPEND_MEDIA_MATCHES, matches)

type Action =
  | SetFullscreenMode
  | SetViewportMatch
  | SetMediaMatch
  | SetMediaMatches

export default Action

